import { apiGet, apiPost } from "./apiClient";

const PROFILE_API = "/api/Authentication/profile";

function pick(obj, ...keys) {
  for (const key of keys) {
    if (obj != null && obj[key] != null) return obj[key];
  }
  return undefined;
}

export function normalizeUserProfile(raw) {
  if (!raw || typeof raw !== "object") return null;

  return {
    id: pick(raw, "id", "Id") ?? 0,
    userName: pick(raw, "userName", "UserName") ?? "",
    role: pick(raw, "role", "Role") ?? "",
    fullName: pick(raw, "fullName", "FullName") ?? "",
    email: pick(raw, "email", "Email") ?? ""
  };
}

function authHeaders(token) {
  return token
    ? {
        Authorization: `Bearer ${token}`
      }
    : {};
}

export async function fetchUserProfile(token) {
  const res = await apiGet(`${PROFILE_API}?token=${encodeURIComponent(token)}`, {
    headers: authHeaders(token)
  });
  if (!res.ok) return res;
  return { ok: true, data: normalizeUserProfile(res.data) };
}

export async function saveUserProfile(token, fullName) {
  const res = await apiPost(
    PROFILE_API,
    { token, fullName },
    { feedback: true, headers: authHeaders(token) }
  );
  if (!res.ok) return res;

  const profileRaw = res.data?.profile ?? res.data?.Profile ?? res.data;
  return {
    ok: true,
    data: normalizeUserProfile(profileRaw),
    message: pick(res.data, "message", "Message")
  };
}
